import React from 'react';
import { Box, Stack } from '@mui/material';
import { ChangelogTag } from '@retail/changelog/types';
import { ChangelogMessageKey, useChangelogTFunction } from '@retail/changelog/i18n';

const tagTints: Record<ChangelogTag, string> = {
  bug: 'red',
  systemnytt: 'sky',
  leverandørnytt: 'green',
};

interface Props {
  tags: ChangelogTag[];
}

export const ChangelogTags: React.FC<Props> = ({ tags }) => {
  const t = useChangelogTFunction();

  if (tags.length === 0) return null;

  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
      {tags.map((tag) => {
        const tint = tagTints[tag];

        return (
          <Box
            component="span"
            key={tag}
            sx={{
              color: `semantic.tint.${tint}.text`,
              bgcolor: `semantic.tint.${tint}.soft`,
              fontSize: '11px',
              px: 1,
              py: 0.25,
              borderRadius: 1.5,
            }}
          >
            {t(`changelog.tags.${tag}` as ChangelogMessageKey, { defaultValue: tag })}
          </Box>
        );
      })}
    </Stack>
  );
};
